module.exports = {"id":"194665","name":"Stefan Ilsanker","rating":"75","photo":"./data/images/photos/0/194665.png","club":{"name":"RB Leipzig","logo":"./data/images/clubs/RBLeipzig.png"},"positions":["MDC","DC","DD"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/StefanIlsanker0.json
// module id = 4006
// module chunks = 0